import omit from "lodash/omit";
import { FetchKPIEventsParams } from "PFCore/services/kpi/fetch_kpi_events";
import { Id, QueryParams } from "PFTypes";

export const KPIKeys = {
  all: () => ["kpi"],
  kpiResults: (engagementId: Id, params?: QueryParams) => [
    ...KPIKeys.all(),
    "results",
    String(engagementId),
    ...(params ? [params] : [])
  ],
  kpiResult: (indicatorId: Id, engagementId: Id) => [
    ...KPIKeys.all(),
    "results",
    String(engagementId),
    String(indicatorId)
  ],
  KPIIndicators: () => [...KPIKeys.all(), "indicators"],
  kpiEvents: (engagementId: Id, params: FetchKPIEventsParams) => [
    ...KPIKeys.all(),
    String(engagementId),
    "events",
    String(params.indicatorId),
    omit(params, "indicatorId")
  ]
};
